@if (vm$ | async; as vm) {
	<section class="container-tax flex">
		<div class="container-info flex">
			<h1 class="title-info text">¿Por qué necesitamos tus datos?</h1>
			<div class="wrap-info flex">
				<div class="wrap-item flex">
					<img src="assets/images/ico_analyze.svg" alt="analyze information" />
					<p class="text item-text">
						Analizaremos la información tributaria de tu empresa para entregarte ofertas de
						financiamiento.
					</p>
				</div>
				<div class="wrap-item flex">
					<img src="assets/images/ico_document.svg" alt="tax returns" />
					<p class="text item-text">
						Revisaremos tus declaraciones de impuestos, registros de compraventa, cesiones, certificados y
						otros antecedentes desde el SII.
					</p>
				</div>
				<div class="wrap-item flex">
					<img src="assets/images/ico_bank.svg" alt="bank approval" />
					<p class="text item-text">
						Cada producto financiero solicitado está sujeto a la aprobación crediticia, según las
						políticas de riesgo vigentes de Bci.
					</p>
				</div>
			</div>
		</div>
		<div class="container-consent">
			<div class="wrap-title flex">
				<img src="assets/images/ico_company.svg" alt="company" />
				<div class="wrap-pyme text">
					<p class="text pyme">Empresa</p>
					<p class="text rut">RUT: {{ vm.customerData.companyRut }}</p>
				</div>
			</div>

			<div>
				<form [formGroup]="taxFolderForm">
					<div class="wrap-password flex">
						<bci-wk-input-password
							class="input-password"
							[label]="'Clave tributaria'"
							formControlName="password"
							[placeholder]="'Ingresa la clave tributaria'"
						>
							<bci-form-msg
								*ngIf="
									passwordControl.touched &&
									passwordControl.invalid &&
									!passwordControl.hasError('invalidPassword')
								"
								type="error"
								>La clave debe tener mínimo 4 caracteres
							</bci-form-msg>
							<bci-form-msg
								*ngIf="passwordControl.hasError('invalidPassword') && passwordControl.touched"
								type="error"
								>Clave incorrecta. Revísala e inténtalo de nuevo.
							</bci-form-msg>
						</bci-wk-input-password>

						<p bciWkTooltipTrigger>
							<span
								class="icon-wrapper"
								(mouseenter)="tooltips.password = true"
								(mouseleave)="tooltips.password = false"
							>
								<i class="material-icons icon-help">
									{{ tooltips.password ? 'help' : 'help_outline' }}
								</i>
							</span>
							<bci-wk-tooltip bciWkTooltipSourceRight [bciWkOwnWidth]="'true'">
								<p bciWkTypeH200 class="text tooltip flex">
									<span class="title-tooltip">¿Cuál es la clave tributaria?</span>
									Es la clave que usas para ingresar al SII. Si no recuerdas tu clave, recupérala en la web
									del SII.
								</p>
							</bci-wk-tooltip>
						</p>
					</div>

					<div class="wrap-consent flex">
						<img src="assets/images/exclamation_blue.svg" alt="exclamation blue" />
						<p class="text title-consent">
							{{ vm.consent.title }}
						</p>
					</div>

					<div class="wrap-terms-conditions flex">
						<div class="wrap-checkbox">
							<bci-wk-checkbox class="checkbox flex" formControlName="termsAndConditions">
							</bci-wk-checkbox>
							<p class="text terms-conditions">
								{{ vm.consent.authorization }}
							</p>
						</div>
						<p class="text details-consent">
							{{ vm.consent.detail }}
						</p>
					</div>

					<div class="wrap-buttons flex">
						<button
							bciWkButtonPrimary
							[disabled]="taxFolderForm.invalid"
							(click)="onContinue(vm.customerData, vm.consent)"
						>
							Continuar
						</button>
					</div>
				</form>
			</div>
		</div>
	</section>
}
